export default "__VITE_ASSET__DHw8R_SX__"